import React, { useState } from "react";
import { screenshotImg } from "../data/data";

import TinySlider from "tiny-slider-react";
import "../../node_modules/tiny-slider/dist/tiny-slider.css";

import Lightbox from "react-18-image-lightbox";
import "../../node_modules/react-18-image-lightbox/style.css";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Screenshot() {
  const { t } = useTranslation();
  let [open, setOpen] = useState<boolean>(false);
  let [activeIndex, setActiveIndex] = useState<number>(0);

  const settings = {
    container: ".tiny-four-item",
    controls: true,
    mouseDrag: true,
    loop: true,
    rewind: true,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    navPosition: "bottom",
    controlsText: [
      '<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>',
      '<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>',
    ],
    nav: false,
    speed: 400,
    gutter: 16,
    responsive: {
      1200: {
        items: 4,
        gutter: 20,
      },
      992: {
        items: 3,
        gutter: 16,
      },
      768: {
        items: 2,
        gutter: 12,
      },
      576: {
        items: 2,
        gutter: 8,
      },
      425: {
        items: 1,
        gutter: 0,
      },
    },
  };

  let openImage = (index: number) => {
    setActiveIndex(index);
    setOpen(true);
  };
  return (
    <div className="grid grid-cols-1 mt-6 md:mt-8 lg:mt-10 relative px-4 md:px-0 overflow-visible">
      <style>
        {`
          .tns-controls button {
            width: 2.5rem !important;
            height: 2.5rem !important;
            background: #624C60 !important;
            border: 1px solid #624C60 !important;
            border-radius: 50% !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
            transition: all 0.3s ease !important;
            transform: scale(1) !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: white !important;
            backdrop-filter: blur(4px) !important;
            position: absolute !important;
            top: 50% !important;
            transform: translateY(-50%) !important;
            z-index: 10 !important;
          }
          .tns-controls button:hover {
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1) !important;
            transform: translateY(-50%) scale(1.05) !important;
            background: #624C60 !important;
            color: white !important;
            border-color: #624C60 !important;
          }
          .tns-controls button:first-child {
            left: 0.25rem !important;
          }
          .tns-controls button:last-child {
            right: 0.25rem !important;
          }
          .tns-controls button:disabled {
            opacity: 0.5 !important;
            cursor: not-allowed !important;
            transform: translateY(-50%) scale(1) !important;
          }
          .tns-controls button:disabled:hover {
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
            transform: translateY(-50%) scale(1) !important;
          }
          @media (min-width: 768px) {
            .tns-controls button {
              width: 3.5rem !important;
              height: 3.5rem !important;
            }
            .tns-controls button:first-child {
              left: -2rem !important;
            }
            .tns-controls button:last-child {
              right: -2rem !important;
            }
          }
          .dark .tns-controls button {
            background: #624C60 !important;
            border-color: #624C60 !important;
            color: white !important;
          }
          .dark .tns-controls button:hover {
            background: #624C60 !important;
            color: white !important;
            border-color: #624C60 !important;
          }
        `}
      </style>
      <TinySlider settings={settings}>
        {screenshotImg.map((item: string, index: number) => {
          return (
            <div className="tiny-slide" key={index}>
              <Link
                to="#"
                onClick={() => openImage(index)}
                className="lightbox block group"
              >
                <div className="relative overflow-hidden rounded-lg md:rounded-xl shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-[1.02]">
                  <img
                    src={item}
                    alt={`Screenshot ${index + 1}`}
                    className="w-full h-auto object-cover transition-transform duration-200 group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-200 flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                      <div className="px-3 py-1.5 bg-white/80 backdrop-blur-sm rounded-full border border-white/20">
                        <span className="text-xs font-medium text-gray-700">
                          {t("screenshots.view")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </TinySlider>

      {open && (
        <Lightbox
          mainSrc={screenshotImg[activeIndex]}
          nextSrc={screenshotImg[(activeIndex + 1) % screenshotImg.length]}
          prevSrc={
            screenshotImg[
              (activeIndex + screenshotImg.length - 1) % screenshotImg.length
            ]
          }
          onCloseRequest={() => setOpen(false)}
          onMovePrevRequest={() =>
            setActiveIndex(
              (activeIndex + screenshotImg.length - 1) % screenshotImg.length
            )
          }
          onMoveNextRequest={() =>
            setActiveIndex((activeIndex + 1) % screenshotImg.length)
          }
        />
      )}
    </div>
  );
}
